/* eslint-disable */
import { SettingsService } from 'src/app/shared/providers/settings.service';
import { Inject, Injectable, OnInit, NgZone } from '@angular/core';
import { Observable, ReplaySubject, Subject, Subscription, switchMap } from 'rxjs';

import {
  Auth,
  signOut,
  signInWithPopup,
  getAuth,
  OAuthProvider,
  User,
  signInWithCredential,
  GoogleAuthProvider,
  getIdTokenResult,
  signInWithEmailAndPassword,
  sendSignInLinkToEmail
} from '@angular/fire/auth';


import {
  collection,
  doc,
  Firestore,
  onSnapshot,
  query,
  where,
  DocumentData,
  getDoc,
  getDocs,
  QuerySnapshot,
  writeBatch,
  setDoc,
} from '@angular/fire/firestore';

// import * as firebase from 'firebase';
import { SplashScreen } from '@capacitor/splash-screen';
import { CARD_PURCHASE_STATUS, CARD_TYPE, FirebaseModelDto, ModelCardRendered, SUBSCRIPTION_STATUS, UploadModelCard, UserSubscriptionStatusDto } from 'src/app/models/card';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { RollbarService, CustomRollbar } from './rollbarlog.service';
import { LOCALSTORAGE_VAR } from 'src/app/models/localstorage';
import { I3DWayUser } from 'src/app/models/user';
import { IGroupedCard } from 'src/app/models/groupedCard';
import { FirebaseStorage, getStorage } from 'firebase/storage';
import { UtilityFunctionsService } from './utility-functions.service';


declare var google: any;

export enum PURCHASE_PROCESS {
  PROCESSING = 'processing',
  DEFAULT = 'default',
  VERIFICATION = 'verification',
  ERROR = 'error',
  SUCCESS = 'success'
}

@Injectable({
  providedIn: 'root'
})
export class FirebaseAuthService {
  currentUser: I3DWayUser;
  firebaseUser: Subject<User> = new Subject();
  firebaseStorage: FirebaseStorage;
  userSubscription: Subscription;
  isSubscriptionRelatedBtnDisabled: boolean = true;

  // ---- Google One Tap state (prevents duplicate prompt across route changes) ----
  private readonly ONE_TAP_SUPPRESS_UNTIL_KEY = 'gsi_one_tap_suppress_until';
  private readonly ONE_TAP_DEFAULT_SUPPRESS_MS = 2 * 60 * 1000; // 2 minutes
  private oneTapInitStarted = false;
  private oneTapLoginInProgress = false;
  private oneTapCheckInterval: any = null;

  // Observable to notify when subscription data is updated
  public userDataUpdated = new ReplaySubject<void>(1);

  isBasicTimeoutPassed: boolean = false;
  isLogoutHappened: boolean = false;
  private hasLoggedFirebaseDocCheck: boolean = false;
  private hasLoggedFirebaseSnapshotData: boolean = false;

  notLoggedUserSubscription: Subject<void> = new Subject();

  private snapshotUnsubscribeFunctions: (() => void)[] = [];
  private firebaseModelsSubscriptionUnsubscribe: () => void;



  constructor(
    private afs: Firestore,
    private afAuth: Auth,
    public settingService: SettingsService,
    @Inject(RollbarService) private rollbar: CustomRollbar,
    private http: HttpClient,
    private ngZone: NgZone,
    private utilityFunctionsService: UtilityFunctionsService
  ) {
    console.log('Fireauth.service constructor Init - authSUB ')

      this.afAuth.onAuthStateChanged((loggedUser: User) => {
        console.log('authSUB TRIGGERED IN init')
        console.log('authStateUser:', loggedUser);
        if (loggedUser) {
          // If user is authenticated, ensure One Tap is not shown anymore.
          this.suppressGoogleOneTapPrompt();
          this.cancelGoogleOneTapPrompt();

          this.firebaseStorage = getStorage();
          const loggedUser3DWay: I3DWayUser = loggedUser as I3DWayUser;
          loggedUser3DWay.subscriptionStatus = this.getSubscriptionStatusCacheInLocalStorage() ? this.getSubscriptionStatusCacheInLocalStorage() : SUBSCRIPTION_STATUS.NOT_SET;
          // DO NOT FORGET TO GET THIS DATA FROM CACHE LATER
          loggedUser3DWay.renderLimit = this.getRenderLimitCache() ? this.getRenderLimitCache() : 10;
          loggedUser3DWay.renderModelsPerCycle = this.getRenderLimitLastCycleValueCache() ? this.getRenderLimitLastCycleValueCache() : 0;
          // ** END TO DO ***
          loggedUser3DWay.uploadsNumber = 0;
          loggedUser3DWay.uploadNumberLimit = 1;
          loggedUser3DWay.isAdmin = false;

          this.currentUser = loggedUser3DWay;


          this.firebaseUser.next(loggedUser);
          this.rollbar.info(`App started, current user: ${loggedUser.uid}, email: ${loggedUser.email}, cachedStatus: ${this.currentUser.subscriptionStatus}, uploadsNumber: ${this.currentUser.uploadsNumber}`);
          console.log('smthDataSubs; user: ', loggedUser.displayName, 'loggedUserObj: ', loggedUser);
          this.updateNumberOfUploads()
          this.setOriginalUidInLocalstorage(this.currentUser.uid);

        }
        else {
          SplashScreen.hide({ fadeOutDuration: 350 });
          this.notLoggedUserSubscription.next();
          console.log('***** USER NOT LOGGED IN ***** WAITING FOR AUTHORIZATION; ');
          this.clearOriginalUidInLocalstorage();
        }

      })

    setTimeout(() => {
      this.isBasicTimeoutPassed = true;
    }, 2000);
  }

  public patch3DWayUser(data: UserSubscriptionStatusDto): void {
    this.isSubscriptionRelatedBtnDisabled = false;
    this.setSubscriptionStatusCacheInLocalStorage(data.user_status);
    this.setRenderLimitCache(data.render_limit);
    this.setRenderLimitLastCycleValueCache(data.render_models_per_cycle);

    this.currentUser.subscriptionStatus = data.user_status;
    this.currentUser.uploadsNumber = data.uploads_count;
    this.currentUser.uploadNumberLimit = data.uploads_max_count;
    this.currentUser.isAdmin = data.admin === true;
    this.currentUser.renderLimit = data.render_limit;
    this.currentUser.renderModelsPerCycle = data.render_models_per_cycle;
    this.currentUser.subscriptionEndDateTime = data.billing_period_end ? data.billing_period_end : undefined;
    this.currentUser.isAutoRenewDisabled = data.autorenew_is_disabled ? data.autorenew_is_disabled : undefined;

    console.log('patch3DWayUser: ', this.currentUser);

    // Notify subscribers that user data has been updated
    this.userDataUpdated.next();

    if(data.uploads_count < 3) {
      this.countUserModelsInFirebase().then((count) => {
        this.currentUser.uploadsNumber = count;
        console.log('countUserModelsInFirebase: ', count)
      });
    }
    // WORKAROUND
    if(data.uploads_count === data.uploads_max_count && data.user_status === SUBSCRIPTION_STATUS.TRIAL) {
      this.currentUser.subscriptionStatus = SUBSCRIPTION_STATUS.TRIAL_EXPIRED;
    }
  }

  public async getUserUid(): Promise<string> {
    if (this.settingService.customUid) {
      return this.settingService.customUid;
    }

    if (this.currentUser) {
      return this.currentUser.uid;
    } else {
      return new Promise((resolve, reject) => {
        const subscription = this.firebaseUser.subscribe((data) => {
          if (this.currentUser) {
            resolve(this.currentUser.uid);
            subscription.unsubscribe();
          }
        });
      });
    }
  }

  public getCurrentUserUID(): string {
    if(this.currentUser) {
      return this.currentUser.uid;
    }
    else {
      throw new Error('No user UID found');
    }
  }

  public getUserToken(forceRefresh: boolean = false): Promise<string> {
    return new Promise((resolve, reject) => {
      if (this.currentUser) {
        resolve(this.currentUser.getIdToken(forceRefresh));
      } else {
        const subscription = this.firebaseUser.subscribe(async (user) => {
          if (this.currentUser) {
            resolve(await this.currentUser.getIdToken(forceRefresh));
            subscription.unsubscribe();
          }
        });
      }
    });
  }

  /**
   * Reads the Firebase Auth custom claim `admin`, the single source of truth for
   * Admin Content access. The same claim gates firestore.rules, the Admin Cloud
   * Functions and the Go web-backend /api/v1/admin/** routes.
   *
   * Distinct from `currentUser.isAdmin`, which comes from the subscription_status
   * API and gates the moderation UI. The two are unrelated.
   *
   * Pass forceRefresh when a stale token would be wrong: a freshly granted claim
   * does not appear in an already-issued ID token for up to an hour.
   */
  public async hasAdminClaim(forceRefresh: boolean = false): Promise<boolean> {
    const user = this.afAuth.currentUser;
    if (!user) {
      return false;
    }

    try {
      const idTokenResult = await getIdTokenResult(user, forceRefresh);
      return idTokenResult.claims['admin'] === true;
    } catch (error) {
      console.warn('Failed to read admin claim', error);
      return false;
    }
  }

  setSubscriptionStatusCacheInLocalStorage(value: string): void {
    localStorage.setItem(LOCALSTORAGE_VAR.SUBSCRIPTION_STATUS_CACHE, value.toString());
  }

  getSubscriptionStatusCacheInLocalStorage(): SUBSCRIPTION_STATUS {
    return localStorage.getItem(LOCALSTORAGE_VAR.SUBSCRIPTION_STATUS_CACHE) as SUBSCRIPTION_STATUS;
  }

  setRenderLimitCache(value: number | null): void {
    localStorage.setItem(LOCALSTORAGE_VAR.RENDER_LIMIT_CACHE, value !== null ? value.toString() : '');
  }

  getRenderLimitCache(): number | null {
    const value = localStorage.getItem(LOCALSTORAGE_VAR.RENDER_LIMIT_CACHE);
    return value !== null && value !== '' ? parseInt(value, 10) : null;
  }

  setRenderLimitLastCycleValueCache(value: number | null): void {
    localStorage.setItem(LOCALSTORAGE_VAR.RENDER_LIMIT_LAST_CYLCLE_VALUE_CACHE, value !== null ? value.toString() : '');
  }

  getRenderLimitLastCycleValueCache(): number | null {
    const value = localStorage.getItem(LOCALSTORAGE_VAR.RENDER_LIMIT_LAST_CYLCLE_VALUE_CACHE);
    return value !== null && value !== '' ? parseInt(value, 10) : null;
  }

  setOriginalUidInLocalstorage(value: string): void {
    localStorage.setItem(LOCALSTORAGE_VAR.ORIGINAL_UID, value.toString());
  }

  clearOriginalUidInLocalstorage(): void {
    localStorage.removeItem(LOCALSTORAGE_VAR.ORIGINAL_UID);
  }

  setFirstTimeScrolledAnyFeed(value: boolean): void {
    localStorage.setItem(LOCALSTORAGE_VAR.FIRST_TIME_SCROLLED_ANY_FEED, value.toString());
  }

  getFirstTimeScrolledAnyFeed(): boolean {
    if(localStorage.getItem(LOCALSTORAGE_VAR.FIRST_TIME_SCROLLED_ANY_FEED) === 'true') return true;
    if(this.currentUser?.uploadsNumber > 0) return true;
    return false;
  }

  public clearLocalStorageData(): void {
    // unblock in future
    // localStorage.removeItem(LOCALSTORAGE_VAR.CUSTOM_UID);
    // localStorage.removeItem(LOCALSTORAGE_VAR.LOG_LEVEL);
    // localStorage.removeItem(LOCALSTORAGE_VAR.FRAME_NUMBER);
    localStorage.removeItem(LOCALSTORAGE_VAR.ORIGINAL_UID);
    localStorage.removeItem(LOCALSTORAGE_VAR.SUBSCRIPTION_STATUS_CACHE);
    localStorage.removeItem(LOCALSTORAGE_VAR.RENDER_LIMIT_CACHE);
    localStorage.removeItem(LOCALSTORAGE_VAR.RENDER_LIMIT_LAST_CYLCLE_VALUE_CACHE);
    localStorage.removeItem(LOCALSTORAGE_VAR.FIRST_TIME_SCROLLED_ANY_FEED);
  }

  public updateNumberOfUploads(): void {
    this.currentUser.uploadsNumber++;
    if (this.currentUser.subscriptionStatus !== SUBSCRIPTION_STATUS.SUBSCRIBER && this.currentUser.uploadsNumber >= this.currentUser.uploadNumberLimit) {
      this.currentUser.subscriptionStatus = SUBSCRIPTION_STATUS.TRIAL_EXPIRED;
    }
  }

  public decreaseNumberOfUploads(): void {
    this.currentUser.uploadsNumber--;
  }

  async getDownloadUrlRef(downloadLink) {
    return downloadLink
  }

  public getDownloadUrl(ref: string): Promise<string> {
    return new Promise((resolve, reject) => {
      resolve('N/A');
    });
  }

  async createFirebaseuser(appleResponse): Promise<string> {
    const provider = new OAuthProvider('apple.com');
    provider.addScope('email');
    provider.addScope('fullName');

    const credential = provider.credential({
      idToken: appleResponse.identityToken
    });

    const userCredential = await signInWithCredential(this.afAuth, credential);

    console.log('After sign in: ', userCredential);
    return userCredential.user.getIdToken();
  }

  async loginWithGoogle(): Promise<string> {
    try {
      console.log('loginWithGoogle started')
    const googleProvider = new GoogleAuthProvider().setCustomParameters({
      prompt: 'select_account'
  });
    // const googleProvider = new firebase.auth.GoogleAuthProvider();
    const googleUserCredential = await signInWithPopup(this.afAuth, googleProvider);
    return googleUserCredential.user.getIdToken()
    } catch (error) {
      throw error;
    }
  }

  async loginWithGoogleNative(token: string): Promise<string> {
    const auth = getAuth();
    const credential = GoogleAuthProvider.credential(token);
    const googleUserCredential = await signInWithCredential(auth, credential);
    return googleUserCredential.user.getIdToken();
  }

  async loginWithEmailAndPassword(email: string, password: string): Promise<string> {
    try {
      const auth = getAuth();
      const credentail = await signInWithEmailAndPassword(auth, email, password);
      const token = await credentail.user.getIdToken();
      return token;
    }
    catch (error) {
      throw error;
    }
  }

  async sendSignInLinkToEmail(email: string): Promise<void> {
    const actionCodeSettings = {
      url: 'https://3dway.io/emailSignIn',
      handleCodeInApp: true,
      iOS: {
        bundleId: 'com.dev-3dway-llc.app.dev'
      },
      android: {
        packageName: 'com.dev-3dway-llc.app.dev',
        installApp: true,
        minimumVersion: '12'
      },
    };

    const auth = getAuth();
    sendSignInLinkToEmail(auth, email, actionCodeSettings)
    .then(() => {
      window.localStorage.setItem('emailForSignIn', email);
    })
    .catch((error) => {
      console.error('Error sending email link:', error);
    });

  }

  async loginWithAppleWeb(): Promise<string> {
    try {
      console.log('loginWithAppleWeb started')
      const auth = getAuth();
      const provider = new OAuthProvider('apple.com');
      provider.addScope('email');
      provider.addScope('name');
      const result = await signInWithPopup(auth, provider);
      console.log('result: ', result);
      return result.user.getIdToken();
    } catch (error) {
      console.error('Authentication failed:', error);
      // Handle the error or rethrow
      throw error;
    }
  }

  async getDocumentsWithLoadStatusNotFinished(): Promise<string[]> {
    const uid = await this.getUserUid();
    const firestore = this.afs; // Ensure this is the Firestore instance

    // Reference to the user's document
    const userDocRef = doc(firestore, '/userdata', uid);

    // Query 1: get documents where loadStatus != 'finished'
    const modelsCollectionRef1 = collection(userDocRef, 'models');
    const q1 = query(modelsCollectionRef1, where('loadStatusMobile', '!=', 'finished'));
    const querySnapshot1: QuerySnapshot<DocumentData> = await getDocs(q1);

    // Query 2: get documents where visibility == false
    const modelsCollectionRef2 = collection(userDocRef, 'models');
    const q2 = query(modelsCollectionRef2, where('visibility', '==', false));
    const querySnapshot2: QuerySnapshot<DocumentData> = await getDocs(q2);

    // Combine results
    const idsFromQuery1 = querySnapshot1.docs.map(doc => doc.id);
    const idsFromQuery2 = querySnapshot2.docs.map(doc => doc.id);

    const combinedIds = idsFromQuery1.filter(id => !idsFromQuery2.includes(id));

    console.log('****** getDocumentsWithLoadStatusNotFinished: ', combinedIds);
    return combinedIds;
  }

  async deleteDocumentsByIds(documentIds: string[]): Promise<void> {
    const uid = await this.getUserUid();

    // Create a batch
    const batch = writeBatch(this.afs);

    documentIds.forEach(documentId => {
      // Get a reference to the document
      const docRef = doc(this.afs, `/userdata/${uid}/models/${documentId}`);
      batch.delete(docRef);
    });

    // Commit the batch
    await batch.commit();
  }

  async deleteDocumentsWithLoadStatusNotFinished(): Promise<void> {
    const documentIds = await this.getDocumentsWithLoadStatusNotFinished();
    await this.deleteDocumentsByIds(documentIds);
  }

  async countUserModelsInFirebase(): Promise<number> {
    const firestore = this.afs; // Get the Firestore instance

    const uid = await this.getUserUid();
    const userDocRef = doc(firestore, `userdata/${uid}`);  // Corrected path to user's document

    // Referencing the sub-collection
    const modelsSubCollection = collection(userDocRef, 'models');

    // Getting documents from the collection
    const querySnapshot = await getDocs(modelsSubCollection);
    const documentIds = querySnapshot.docs.map(doc => doc.id);
    console.log('****** countUserModelsInFirebase: ', documentIds);
    return documentIds.length;
  }


  getFirebaseModelsWithPreprocessingStatusUpdates(): Observable<FirebaseModelDto[]> {
    const mobileLoadStatus = 'loadStatusMobile';
    const webLoadStatus = 'loadStatusWeb';
    const userModelsPath = `userdata/${this.currentUser.uid}/models`;

    const processingStatuses = ['processStarted', 'readyToProcess', 'inQueue', 'podStarted', 'modelDownload', 'rawThumbnailRendered', 'thumbnailRendered', 'thumbnailUploaded', 'rawVideoRendered', 'videoRendered', 'renderModelError', 'generalError'];

    // Create an observable to watch for real-time updates
    return new Observable<FirebaseModelDto[]>(observer => {
      // Query models where at least one platform is still processing
      const modelsRef = collection(this.afs, userModelsPath);
      const unsubscribe = onSnapshot(modelsRef, snapshot => {
        const models = snapshot.docs
          .map(doc => ({
            id: doc.id,
            ...(doc.data() as FirebaseModelDto)
          }))
          .filter(model => {
            // Include model if either platform is still processing
            const mobileStatus = model[mobileLoadStatus];
            const webStatus = model[webLoadStatus];
            const isMobileProcessing = processingStatuses.includes(mobileStatus);
            const isWebProcessing = processingStatuses.includes(webStatus);
            return isMobileProcessing || isWebProcessing;
          });
        observer.next(models);
      }, error => {
        observer.error(error);
      });

      // Store the unsubscribe function
      this.firebaseModelsSubscriptionUnsubscribe = unsubscribe;

      // Unsubscribe from Firestore listener when the observable is unsubscribed
      return unsubscribe;
    });
  }


  createSubscriptionForStatusChangesInFirebase(): Observable<any> {
    return new Observable<FirebaseModelDto>(observer => {
      const docRef = doc(this.afs, `userdata/${this.currentUser.uid}`);

      let isFirstSnapshot = true;

      const unsubscribe = onSnapshot(docRef, (doc) => {
        if (doc.exists()) {
          if (isFirstSnapshot) {
            isFirstSnapshot = false; // Skip the first snapshot
            return;
          }
          const data = doc.data();
          const relevantData: Partial<UserSubscriptionStatusDto> = {
            user_status: data.user_status,
            user_status_upd: data.user_status_upd,
            billing_cycle_upd: data.billing_cycle_upd,
          };

          observer.next({ id: doc.id, ...relevantData } as any);
        } else {
          observer.error('Document does not exist');
        }
      }, (error) => {
        observer.error(error);
      });
      this.addSnapshotUnsubscribeFunction(unsubscribe);
      // Cleanup subscription on unsubscribe
      return { unsubscribe };
    });
  }



  public async getFirebaseModelsData(handler: Function, uploadingCard: IGroupedCard): Promise<void> {
    const fileName = uploadingCard.fileName;
    const uid = await this.getUserUid();

    const modelDocRef = doc(this.afs, `userdata/${uid}/models/${fileName}`);
    const docSnapshot = await getDoc(modelDocRef);

    if (docSnapshot.exists()) {
      this.logFirebaseDocCheckOnce('DOC EXISTS');
      const existingData = docSnapshot.data();
      await this.patchDefaultModelInFirestore(uploadingCard, uid, existingData);
      const unsubscribe = this.createSnapshotSubscription(handler, fileName, uid);
      this.addSnapshotUnsubscribeFunction(unsubscribe);
    } else {
      this.logFirebaseDocCheckOnce('DOC NOT EXISTS');
      await this.patchDefaultModelInFirestore(uploadingCard, uid);
      const unsubscribe = this.createSnapshotSubscription(handler, fileName, uid);
      this.addSnapshotUnsubscribeFunction(unsubscribe);
    }
  }

  private createSnapshotSubscription(handler: Function, fileName: string, uid: string): () => void {
    const docRef = doc(this.afs, `userdata/${uid}/models/${fileName}`);
    const _unsubscribe = onSnapshot(docRef, {
      includeMetadataChanges: true
    }, (snapshot) => {
      if (snapshot.exists()) {
        handler(snapshot.data(), _unsubscribe);
        this.logFirebaseSnapshotOnce(snapshot.data());
      }
    }, ex => {
      console.error('Error getting document:', ex);
    });
    return _unsubscribe;
    }

    // Add this method to add unsubscribe functions to the list
    public addSnapshotUnsubscribeFunction(unsubscribeFunction: () => void): void {
      this.snapshotUnsubscribeFunctions.push(unsubscribeFunction);
    }

    // Add this method to unsubscribe from all snapshot listeners
    public unsubscribeAllSnapshots(): void {
      this.snapshotUnsubscribeFunctions.forEach(unsubscribe => unsubscribe());
      this.snapshotUnsubscribeFunctions = [];
    }

    public unsubscribeFirebaseModelsUpdates(): void {
      if (this.firebaseModelsSubscriptionUnsubscribe) {
        this.firebaseModelsSubscriptionUnsubscribe();
        this.firebaseModelsSubscriptionUnsubscribe = null;
      }
    }

    private logFirebaseDocCheckOnce(message: string): void {
      if (this.hasLoggedFirebaseDocCheck) {
        return;
      }
      this.hasLoggedFirebaseDocCheck = true;
      console.log(message);
    }

    private logFirebaseSnapshotOnce(data: any): void {
      if (this.hasLoggedFirebaseSnapshotData) {
        return;
      }
      this.hasLoggedFirebaseSnapshotData = true;
      console.log('GetData From Firebase:', data);
    }

  async logout() {
    const currentUser = this.afAuth.currentUser;
    if (currentUser) {
      console.log('user', currentUser);

      const token = await currentUser.getIdToken();
      console.log(token);

      const idTokenResult = await getIdTokenResult(currentUser);
      console.log(idTokenResult);
    }

    await signOut(this.afAuth);
    this.unsubscribeAllSnapshots();
    this.unsubscribeFirebaseModelsUpdates();
    this.currentUser = undefined;
  }

  public async patchDefaultModelInFirestore(uploadingModel: IGroupedCard, uid: string, existingData?: DocumentData): Promise<void> {
    // use carefully !!!!!;
    const fileName = uploadingModel.fileName;

    const modelDocRef = doc(this.afs, `userdata/${uid}/models/${fileName}`);

    const sampleModelData: any = {
      id: fileName,
      parentCollectionId: uploadingModel.linkedCollectionId ? uploadingModel.linkedCollectionId : 'undefined',
      modifiedDate: uploadingModel.modifiedDate ? uploadingModel.modifiedDate.toString() :  Math.floor(Date.now() / 1000).toString(),
      cardContentMobile: 'undefined',
      cardContentWeb: 'undefined',
      cardType: CARD_TYPE.MODEL,
      cardCategory: 'undefined',
      cardAuthor: uid,
      cardTitle: fileName,
      cardDescription: 'The mecha is co-piloted by two different players, the first serving as a pilot, and the second serving as a gunner.',
      purchaseStatus: CARD_PURCHASE_STATUS.UPLOADED,
      cardPosterMobile: '',
      cardPosterWeb: '',
      cardPrice: 0,
      loadProgressMobile: '0',
      loadProgressWeb: '0',
      loadStatusMobile: 'processStarted',
      loadStatusWeb: 'processStarted',
      warningMobile: '',
      warningWeb: ''
    };
    try {
      const patchData = this.getMissingModelFields(sampleModelData, existingData);
      if (Object.keys(patchData).length === 0) {
        return;
      }
      await setDoc(modelDocRef, patchData, { merge: true });
      console.log('Document successfully written!');
    } catch (error) {
      console.error('Error writing document:', error);
    }

  }

  private getMissingModelFields(defaultData: Record<string, any>, existingData?: DocumentData): Record<string, any> {
    if (!existingData) {
      return defaultData;
    }
    const patchData: Record<string, any> = {};
    Object.keys(defaultData).forEach((key) => {
      const existingValue = (existingData as any)[key];
      if (existingValue === undefined || existingValue === null) {
        patchData[key] = defaultData[key];
      }
    });
    return patchData;
  }

  public async cloneModel(originalModelId: string, newStatus: string): Promise<void> {
    try {
      const uid = await this.getUserUid();
      const originalDocRef = doc(this.afs, `userdata/${uid}/models/${originalModelId}`);
      const originalDoc = await getDoc(originalDocRef);
      if (!originalDoc.exists()) throw new Error(`Model with ID ${originalModelId} not found`);

      const originalData = originalDoc.data() as FirebaseModelDto;
      const newModelId = `${originalModelId}-${Date.now().toString().slice(-6)}`;
      const newDocRef = doc(this.afs, `userdata/${uid}/models/${newModelId}`);

      if ((await getDoc(newDocRef)).exists()) throw new Error(`Generated ID ${newModelId} already exists. Try later`);

      await setDoc(newDocRef, {
        ...originalData,
        id: newModelId,
        model: newModelId,
        loadStatusMobile: newStatus,
        loadStatusWeb: newStatus,
        cardTitle: `${originalData.cardTitle} Cloned`,
      }, { merge: true });

      console.log(`Successfully cloned with ${newModelId}`);
    } catch (error) {
      console.error('Clone Error:', error);
      throw error;
    }
  }

  public async addTexturesToModel(modelId: string, texturesRootPath: string): Promise<void> {
    try {
      const uid = await this.getUserUid();
      const modelDocRef = doc(this.afs, `userdata/${uid}/models/${modelId}`);

      const texturesArray = [
        'textures/F1_Tire_Yellow_BaseColor.png',
        'textures/F1_Tire_Yellow_Roughness.png',
        'textures/F1_Tire_Yellow_Normal.png',
        'textures/F1_Tire_Yellow_Metallic.png',
        'textures/F1_cockpit_BaseColor.png',
        'textures/F1_Tire_Yellow_Height.png'
      ];

      await setDoc(modelDocRef, {
        mappedTextures: texturesArray, // All textures needed for the model
        missingTextures: texturesArray, // Initially all textures are missing
        texturesRootPath: texturesRootPath
      }, { merge: true });

      console.log(`Successfully added textures and texturesRootPath to model ${modelId}`);
    } catch (error) {
      console.error('Error adding textures to model:', error);
      throw error;
    }
  }

  public async removeTextureFromMissing(modelId: string, texturePath: string): Promise<void> {
    try {
      const uid = await this.getUserUid();
      const modelDocRef = doc(this.afs, `userdata/${uid}/models/${modelId}`);

      // Get current document data
      const docSnapshot = await getDoc(modelDocRef);
      if (!docSnapshot.exists()) {
        throw new Error(`Model ${modelId} not found`);
      }

      const currentData = docSnapshot.data();
      const currentMissingTextures = currentData.missingTextures || [];

      // Remove from missingTextures only (mappedTextures contains all textures and doesn't change)
      const updatedMissingTextures = currentMissingTextures.filter((texture: string) => texture !== texturePath);

      // Update the document
      await setDoc(modelDocRef, {
        missingTextures: updatedMissingTextures
      }, { merge: true });

      console.log(`Successfully removed texture ${texturePath} from missing textures for model ${modelId}`);
    } catch (error) {
      console.error('Error removing texture from missing:', error);
      throw error;
    }
  }

  public async updateModelStatusToReadyToProcess(modelId: string): Promise<void> {
    try {
      const uid = await this.getUserUid();
      const modelDocRef = doc(this.afs, `userdata/${uid}/models/${modelId}`);

      // Update both mobile and web status to readyToProcess
      await setDoc(modelDocRef, {
        loadStatusMobile: 'readyToProcess',
        loadStatusWeb: 'readyToProcess'
      }, { merge: true });

      console.log(`Successfully updated model ${modelId} status to readyToProcess`);
    } catch (error) {
      console.error('Error updating model status:', error);
      throw error;
    }
  }

  public async appendTexturesToModel(modelId: string, newTextures: string[]): Promise<void> {
    if (!newTextures || newTextures.length === 0) return;
    try {
      const uid = await this.getUserUid();
      const modelDocRef = doc(this.afs, `userdata/${uid}/models/${modelId}`);

      const docSnap = await getDoc(modelDocRef);
      if (!docSnap.exists()) {
        console.warn(`appendTexturesToModel: model ${modelId} not found`);
        return;
      }
      const data = docSnap.data();
      const mapped: string[] = data.mappedTextures || [];
      const missing: string[] = data.missingTextures || [];

      let updated = false;
      newTextures.forEach(tex => {
        if (!mapped.includes(tex)) {
          mapped.push(tex);
          updated = true;
        }
        if (!missing.includes(tex)) {
          missing.push(tex);
          updated = true;
        }
      });
      if (!updated) return;

      await setDoc(modelDocRef, {
        mappedTextures: mapped,
        missingTextures: missing
      }, { merge: true });
      console.log(`appendTexturesToModel: added ${newTextures.length} textures to model ${modelId}`);
    } catch (error) {
      console.error('appendTexturesToModel error:', error);
    }
  }

  public initializeGoogleOneTap(onSuccess: () => void, onError: (err: any) => void) {
    if (environment.type !== 'web') {
      return;
    }

    if (this.settingService.devicePlatform !== 'web' && this.settingService.devicePlatform !== undefined) {
      return;
    }

    if (this.utilityFunctionsService.detectMobileDevice()) {
      return;
    }

    // Already authenticated or we're in the middle of One Tap login → don't show prompt.
    if (this.currentUser || (this.afAuth as any)?.currentUser) return;
    if (this.oneTapLoginInProgress) return;
    if (this.isGoogleOneTapSuppressed()) return;

    // Prevent multiple intervals/initializations if called from several components.
    if (this.oneTapInitStarted) return;
    this.oneTapInitStarted = true;

    const checkGoogleInterval = setInterval(() => {
      if (typeof google !== 'undefined' && google.accounts) {
        clearInterval(checkGoogleInterval);
        this.oneTapCheckInterval = null;

        const clientId = environment.production
          ? '526232867167-ngn4f33qgjqrcalhuf12ukilukak95eg.apps.googleusercontent.com'
          : '900901699747-tnfv024l3o72fdil2udoqb6pmpp8j1jm.apps.googleusercontent.com';

        google.accounts.id.initialize({
          client_id: clientId,
          callback: (response: any) => {
              this.handleGoogleOneTapResponse(response, onSuccess, onError);
          },
          // FedCM: let the browser mediate the prompt when available.
          // If a user disables FedCM in site settings, the prompt may not show (expected).
          use_fedcm_for_prompt: true,
          auto_select: false,
          cancel_on_tap_outside: false
        });

        // With FedCM, "prompt moment" helpers (isDisplayed/isNotDisplayed/getNotDisplayedReason)
        // are not reliable / may be unsupported. Keep it simple.
        google.accounts.id.prompt();
      }
    }, 500);
    this.oneTapCheckInterval = checkGoogleInterval;

    setTimeout(() => clearInterval(checkGoogleInterval), 10000);
  }

  private async handleGoogleOneTapResponse(response: any, onSuccess: () => void, onError: (err: any) => void) {
    console.log('Google One Tap response received');
    try {
      // Avoid re-prompting during route changes while auth state is still updating.
      this.oneTapLoginInProgress = true;
      this.suppressGoogleOneTapPrompt();
      this.cancelGoogleOneTapPrompt();

      await this.loginWithGoogleNative(response.credential);
      this.ngZone.run(() => {
          onSuccess();
      });
    } catch (error) {
      console.error('Google One Tap login error:', error);
      // If login failed, keep suppression short to avoid prompt-spam loops.
      this.suppressGoogleOneTapPrompt(15 * 1000);
      this.ngZone.run(() => {
          onError(error);
      });
    } finally {
      this.oneTapLoginInProgress = false;
    }
  }

  private isGoogleOneTapSuppressed(): boolean {
    try {
      const untilRaw = sessionStorage.getItem(this.ONE_TAP_SUPPRESS_UNTIL_KEY);
      const until = untilRaw ? Number(untilRaw) : 0;
      return Number.isFinite(until) && Date.now() < until;
    } catch {
      return false;
    }
  }

  private suppressGoogleOneTapPrompt(ms: number = this.ONE_TAP_DEFAULT_SUPPRESS_MS): void {
    try {
      sessionStorage.setItem(this.ONE_TAP_SUPPRESS_UNTIL_KEY, String(Date.now() + ms));
    } catch { /* noop */ }
  }

  private cancelGoogleOneTapPrompt(): void {
    try {
      if (typeof google !== 'undefined' && google?.accounts?.id?.cancel) {
        google.accounts.id.cancel();
      }
    } catch { /* noop */ }
  }

}
